<template>
  <div class="hello">

    <ui-modal ref="err_modal" title="Messages">
      <ui-alert type="error" :dismissible="false" v-if="messagesErreur.length > 0">
        <ul v-if="messagesErreur.length > 0">
          <li  v-for="item in messagesErreur" :key="item" >
            {{item}}
          </li >
        </ul>
      </ui-alert>


      <div  v-if="messagesErreur.length <= 0">
        <ui-alert type="success" :dismissible="false">
                        {{messageSucces}}
        </ui-alert>
      </div>
    </ui-modal>

<div v-if='!addMode'>

<table>
<tr>
  <td><ui-textbox label="Id" placeholder="" v-model="formSearch.id"></ui-textbox></td>
  <td style="width:275px;"><ui-datepicker placeholder="" v-model="formSearch.dateEvenement" >Date Evenement</ui-datepicker></td>
  <td style="width:300px;"><ui-select
      label="Type evenement"
      placeholder=""
      :options="listTypeEvnts"
      :keys="{ label: 'libelle', value: 'id' }"
      v-model="formSearch.typeEvent"
  ></ui-select></td>
  <td><ui-textbox label="Code" placeholder="" v-model="formSearch.shortName"></ui-textbox></td>
  <td><ui-textbox label="Libelle" placeholder="" v-model="formSearch.libelle"></ui-textbox></td>
  <td><ui-textbox label="Reference Bo" placeholder="" v-model="formSearch.referenceBo"></ui-textbox></td>
  <td style="width:275px;"><ui-datepicker placeholder="" v-model="formSearch.datePubBo" >Date publication</ui-datepicker></td>



</tr>
</table>


<ui-button :color="'green'" @click="chercher()">Chercher</ui-button>
<ui-button :color="'red'" @click="showFormAdd()" style="margin-left:5px;">Nouveau Evenement</ui-button>

<div v-if="hasNext || hasPrevious">
  <br>
  <ui-button :color="'green'" @click="precedent()" :disabled="!hasPrevious">Precedent</ui-button>
  <ui-button :color="'green'" @click="suivant()" :disabled="!hasNext">Suivant</ui-button>

</div>

<b-table striped hover :items="listEvents" :fields="fields">
  <!-- A virtual column -->

  <template #cell(actions)="data">
    <ui-button :color="'green'" @click="update(data)">Modifier</ui-button>
  </template>

</b-table>


</div>
<div v-if='addMode'>
  <div style="width:50%">
    <div>id : {{formEvent.id}}</div>
    <ui-datepicker placeholder="" v-model="formEvent.dateEvenement" required>Date evenement</ui-datepicker>
    <div>code : {{formEvent.shortName}}</div>

    <ui-select
        label="Type evenement"
        placeholder=""
        :options="listTypeEvnts"
        :keys="{ label: 'libelle', value: 'id' }"
        v-model="formEvent.typeEvent"
    ></ui-select>

    <ui-textbox label="Libelle" placeholder="" v-model="formEvent.libelle"></ui-textbox>
    <ui-textbox label="Reference publication" placeholder="" v-model="formEvent.referenceBo" required></ui-textbox>
    <ui-datepicker placeholder="" v-model="formEvent.datePubBo" required>Date publication</ui-datepicker>




  </div>
  <ui-button :color="'green'" @click="enregistrer()">Enregistrer</ui-button>
  <ui-button :color="'red'" @click="annuler()" style="margin-left:5px;">Retour</ui-button>

</div>









  </div>
</template>

<script>
import { getEvents, getTypeEvents, saveEvent, searchEvents } from '../services/ApiService.js'
export default {
  name: 'Evenement',
  props: {

  },
  mounted() {

    getTypeEvents().then(response => {

       this.listTypeEvnts = response.data;
       this.listTypeEvnts.unshift({id:null,code:'',libelle:'Choix Type evenement'});
   }).catch(err => this.showResponseError(err))


  },
  data() {

       return {
           dateDebut: null,
           dateFin: null,
           listEvents: null,
           hasNext:false,
           hasPrevious:false,
           addMode: false,
           showMessageSucces: false,
           messageSucces: '',

           showMessageErreur: false,
           messagesErreur: [],

           formEvent : {
             typeEvent : {
               id:0,
               code:'',
               libelle:''
             },
             id:null,
             dateEvenement:null,
             libelle: '',
             referenceBo: '',
             shortName: '',
             datePubBo: null,
             currPage: 0
           },

           formSearch : {
             id : null,
             typeEvent : {
               id: 0,
               code:'',
               libelle:''
             },
             dateEvenement:null,
             idTypeEvent :null,
             shortName:'',
             libelle:'',
             referenceBo:'',
             datePubBo:null,
             currPage: 0


           },

           fields: [
                {
                  key: "id",
                  label: "Id",

                },
                {
                  key: "dateEvenement",
                  label: "Date evenement",

                },
                {
                  key: "typeEvent.libelle",
                  label: "Type evenement",

                },
                {
                  key: "shortName",
                  label: "Code",

                },
                {
                  key: "libelle",
                  label: "Libelle",

                },
                {
                  key: "referenceBo",
                  label: "Reference Bo",

                },
                {
                  key: "datePubBo",
                  label: "Date Publication Bo",

                },
                { key: "actions" }
              ],
              listTypeEvnts :[]
         }
       },

       methods : {

         chercher() {
            if(this.formSearch.typeEvent.id === 0) {
              this.formSearch.idTypeEvent = null;
            } else {
              this.formSearch.idTypeEvent = this.formSearch.typeEvent.id;
            }


           searchEvents(this.formSearch).then(response => {
              this.listEvents = response.data.content;
              this.hasNext = response.data.hasNext;
              this.hasPrevious = response.data.hasPrevious;

      }).catch(err => this.showResponseError(err))
    },
    suivant() {
      this.formSearch.currPage = this.formSearch.currPage + 1;
      this.chercher();
    },
    precedent() {
      this.formSearch.currPage = this.formSearch.currPage - 1;
      this.chercher();
    },
    showFormAdd() {
      this.addMode = true
    },
    enregistrer() {
      if(!this.valdateForm()) {
        this.$refs["err_modal"].open();
        return;
      }

      saveEvent(this.formEvent).then((evt) => {
         this.fillFormO(evt.data);
         this.showMessageSucces = true;
         this.messageSucces = "Evenement enregistre avec succe";
         this.$refs["err_modal"].open();

     }).catch(err => this.showResponseError(err))

    },
    annuler() {
      this.resetForm()
      this.addMode = false
      this.showMessageSucces = false
      this.showMessageErreur = false
    },
    resetForm() {
      this.formEvent.id = null;
      this.formEvent.dateEvenement = null;
      this.formEvent.libelle = '';
      this.formEvent.referenceBo = '';
      this.formEvent.datePubBo = null;
      this.formEvent.shortName = '';
    },
    fillFormO(evt) {
      this.formEvent = evt;
      /*this.formEvent.id = evt.id;
      this.formEvent.dateEvenement = evt.dateEvenement;
      this.formEvent.libelle = evt.libelle;
      this.formEvent.referenceBo = evt.referenceBo;
      this.formEvent.datePubBo = evt.datePubBo;*/


    },
    fillForm(evts) {
      if(evts.length > 0) {
        this.fillFormO(evts[0]);
      } else {
        this.resetForm();
      }

    },

    valdateForm() {
      this.messagesErreur =[];
      if(!this.formEvent.typeEvent || !this.formEvent.typeEvent.id) {
        this.messagesErreur.push("Le type evenement est obligatoire");
      }
      if(!this.formEvent.dateEvenement) {
        this.messagesErreur.push("La date evenement est obligatoire");
      }
      if(!this.formEvent.libelle) {
        this.messagesErreur.push("Le libelle est obligatoire");
      }
      if(!this.formEvent.referenceBo) {
        this.messagesErreur.push("La refrence BO est obligatoire");
      }
      if(!this.formEvent.datePubBo) {
        this.messagesErreur.push("La Date de publication est obligatoire");
      }

      this.showMessageErreur = this.messagesErreur.length > 0 ;
      return !this.showMessageErreur;

    },

    update(data) {

      this.resetForm();

      getEvents(this.listEvents[data.index].id).then(response => {
         this.fillForm(response.data);
         this.showFormAdd();
      }).catch(err => this.showResponseError(err))


    },

    showResponseError(err) {
      this.messagesErreur =[];
      if(err.status === 403) {
        this.messagesErreur.push("Acces refuse");
      } else {
        this.messagesErreur.push("Erreur technique");
      }
      this.showMessageErreur = true;
      this.$refs["err_modal"].open();
    },


  },

   computed: {
    typeEvents() {
      return getTypeEvents();
    }

   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
